export default {"src":"/uk/_next/static/media/spot-customer-service.9f578a96.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};